import { postConsentDecisionRequest } from 'PrivateApis';

import { UserStateStatic } from 'Context/user';

import { getCookieValue } from 'Utilities';

import type { ConsentObject } from './cookieConsent.types';

// Temporary constants. Update when versioning strategy is defined
export const CONSENT_MESSAGE_VERSION = '1.0.0';
export const CONSENT_COOKIE_POLICY_VERSION = '1.0.0';
export const CONSENT_PRIVACY_POLICY_VERSION = '1.0.0';
export const CONSENT_SYSTEM_VERSION = '1.0.0';

export type ConsentMethod = 'banner_accept_all' | 'banner_essential_only' | 'preference_centre';

type ConsentServicePayload = {
  anonymous_id: string;
  consent_system_version: string;
  cookie_policy_version: string;
  decisions: ConsentObject;
  message_version: string;
  method: ConsentMethod;
  privacy_policy_version: string;
  source: 'web';
  user_id?: number;
};

let cachedAnonymousId: string;

const getAnonymousId = (): string => {
  if (!cachedAnonymousId) {
    cachedAnonymousId = getCookieValue('Optimizely-User-Id') || crypto.randomUUID();
  }

  return cachedAnonymousId;
};

const getUserId = (): number | undefined => {
  const { state } = UserStateStatic as { state: { dpSellerId?: number } };
  const dpSellerId = state?.dpSellerId;
  return Number.isInteger(dpSellerId) ? dpSellerId : undefined;
};

export const postConsentDecision = (
  decisions: ConsentObject,
  method: ConsentMethod,
): void => {
  const userId = getUserId();

  const payload: ConsentServicePayload = {
    anonymous_id: getAnonymousId(),
    consent_system_version: CONSENT_SYSTEM_VERSION,
    cookie_policy_version: CONSENT_COOKIE_POLICY_VERSION,
    decisions,
    message_version: CONSENT_MESSAGE_VERSION,
    method,
    privacy_policy_version: CONSENT_PRIVACY_POLICY_VERSION,
    source: 'web',
    ...(userId !== undefined && { user_id: userId }),
  };

  postConsentDecisionRequest(payload).catch((error) => {
    window?.Sentry?.captureException?.(error, {
      extra: {
        isLoggedIn: userId !== undefined,
        method,
        source: 'web',
      },
      tags: {
        fetch: 'consent-service',
      },
    });
  });
};
